export class DecisionModel {
  patientcode = '' ;
  decdate = '2024-012-01' ;
  declocation = '' ;
  decnotes = '' ;
  userid = '' ;
  username = '' ;
  dectime = '2024-01-01' ;

 }
